<template>
  <div ref="container">
    <code-model  ref="codeModel" ></code-model>
    <a-modal :z-index="99" :title="title" width="90%" :visible="visible" :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @cancel="handleCancel" cancelText="关闭" style="top:20px;">
      <template slot="footer">
<!--        <a-button key="back" v-if="!uuid" type="primary" @click="submit">确认</a-button>-->
        <a-button key="back" @click="handleCancel">关闭</a-button>
      </template>
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
      </div>
      <!-- table区域-begin -->
      <a-table bordered ref="table" size="middle" :pagination="false" rowKey="id" :columns="columns" :dataSource="dataSource" :loading="loading" @change="handleTableChange">
        <span slot="packType" slot-scope="text, record">
          <span>{{record.packType}}级包装</span>
        </span>

        <span slot="action" slot-scope="text, record">
            <a @click="codeDetail(record)">明细</a>
        </span>

        <template slot="createTime" slot-scope="createTime">
          <span>{{ timestampToTime(createTime) }}</span>
        </template>

        <template slot="packSpec" slot-scope="text, record">
          <div v-if="record.packSpec && record.packSpec.split(',')">
            <div v-for="it in record.packSpec.split(',' || '，')">{{ it.substring(9) ? it : '' }}</div>
          </div>
        </template>

        <template slot="status" slot-scope="status">
          <a-tag v-if="status == -1" color="red">采集异常</a-tag>
          <a-tag v-if="status == -2" color="red">入库异常</a-tag>
          <a-tag v-if="status == 0" color="orange">上传中</a-tag>
          <a-tag v-if="status == 1" color="blue">待入库</a-tag>
          <a-tag v-if="status == 2" color="green">已入库</a-tag>
          <a-tag v-if="status == 3" color="orange">入库中</a-tag>
        </template>
      </a-table>
    </a-modal>

  </div>
</template>
<script>
// import BillDetail from '../../bill/dialog/BillDetail'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import { findBillDetailByNumber, batchDetails } from '@/api/api'
import { mixinDevice } from '@/utils/mixin'

import codeModel from './codeModel'

export default {
  name: 'MaterialInOutList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    codeModel,
    JEllipsis,
  },
  data() {
    return {
      loading: false,
      title: '操作',
      visible: false,
      disableMixinCreated: false,
      toFromType: '',
      currentMaterialId: '',
      dataSource: [],
      fileName: '',
      uuid: '',
      // 表头
      columns: [
        {
          "title": "产品名称",
          "dataIndex": "materialName"
        },
        { title: 'DI信息', dataIndex: 'di', width: 100 },
        {
          "title": "批次",
          "dataIndex": "batchNumber"
        },
        {
          "title": "包装详情",
          "dataIndex": "details",
          align: 'center',
        },

        {
          "title": "规格",
          "dataIndex": "standard"
        },

        {
          "title": "包装规格",
          "dataIndex": "packSpec",
          width: 100, scopedSlots: { customRender: 'packSpec' }
        },
        {
          "title": "采集日期",
          "dataIndex": "createTime",
          scopedSlots: { customRender: 'createTime' }
        },
        {
          "title": "状态",
          "dataIndex": "status",
          align: 'center', width: 40, scopedSlots: { customRender: 'status' }
        },

        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      labelCol: {
        xs: { span: 1 },
        sm: { span: 2 },
      },
      wrapperCol: {
        xs: { span: 10 },
        sm: { span: 16 },
      },
    }
  },
  created() {},
  methods: {
    async show(e) {
      this.visible = true

      const res = await batchDetails({ materialId: e.materialId, batchNumber:e.batchNumber,currentPage:1, pageSize:100000})

      this.dataSource = res.data.list

      console.log(res,'res')

    },
    codeDetail(record){
      this.$refs.codeModel.show(record)
      this.$refs.codeModel.title = record.batchNumber + ' 批次明细'
    },
    close() {
      this.$emit('close')
      this.visible = false
      if (!this.uuid) {
        this.$emit('fatherMethod')
      }
    },
    handleCancel() {
      this.close()
    },

    myHandleDetail(record) {
      let that = this
      this.toFromType = record.fromType
      findBillDetailByNumber({ number: record.number }).then((res) => {
        if (res && res.code === 200) {
          this.$refs.billDetail.isCanBackCheck = false
          that.$refs.billDetail.show(res.data, record.type)
          that.$refs.billDetail.title = '详情'
        }
      })
    },

  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>